import { useQuery } from "@tanstack/react-query";
import { type ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";

import { me, type CurrentUser } from "../../api/auth.ts";
import { tokens } from "../../api/client.ts";

export default function RequireAuth({ children }: { children: ReactNode }) {
  const location = useLocation();
  const hasToken = Boolean(tokens.access);
  const { data, isLoading, isError } = useQuery<CurrentUser>({
    queryKey: ["auth", "me"],
    queryFn: me,
    enabled: hasToken,
    retry: false,
  });

  if (!hasToken || isError) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  if (isLoading || !data) {
    return (
      <div className="grid min-h-screen place-items-center text-sm text-slate-500">Loading…</div>
    );
  }
  return <>{children}</>;
}
